// hide google review widget ads

document.addEventListener("DOMContentLoaded", function() {
  // setTimeout(function() {
  //   var links = document.querySelectorAll('.WidgetBackground__ContentContainer-sc > a');
  //   links.forEach(function(el){
  //     el.style.setProperty('display', 'none', 'important');
  //   });
  // }, 3500); 
});